export default __webpack_public_path__ + "static/media/shield-check.ff88897f.svg";